import {ChevronRightIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {useSlots} from '@primer/react/experimental'
import Title from './Title'
import Description from './Description'
import itemStyles from './Item.module.css'
import {clsx} from 'clsx'
import styles from './LinkItem.module.css'

const slotConfig = {
  title: Title,
  description: Description,
}

export type ControlGroupLinkProps = {
  href: string
  children: React.ReactNode
  leadingIcon?: React.ReactNode
  nestedLevel?: 0 | 1 | 2
  value?: string
}

const LinkItem = ({children, leadingIcon = null, href, value, nestedLevel = 0}: ControlGroupLinkProps) => {
  const [slots] = useSlots(children, slotConfig)
  const {title, description} = slots

  return (
    <div className={clsx(itemStyles.container, styles.container)} style={{'--nested-level': nestedLevel}}>
      <div className={itemStyles.contents}>
        {leadingIcon ? (
          <div className={itemStyles.leadingVisual}>
            <div className={styles.leadingIcon}>{leadingIcon}</div>
          </div>
        ) : null}

        <Link href={href} className={clsx(itemStyles.title, styles.linkOverlay)}>
          {title}
        </Link>

        <div className={clsx('descriptionBox', itemStyles.description)}>{description}</div>

        <div className={itemStyles.trailingVisual}>
          <div className={styles.linkIndicator}>
            {value && <span>{value}</span>}
            <ChevronRightIcon />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkItem
